(() => {
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => {
    es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  document.querySelectorAll('.vl-rv').forEach((el) => io ? io.observe(el) : el.classList.add('is-in'));

  document.querySelectorAll('[data-vl-buy]').forEach((box) => {
    const idInput = box.querySelector('[data-vl-id]');
    const prices = document.querySelectorAll('[data-vl-price]');
    const gift = box.querySelector('[data-vl-gift]');
    const giftTxt = box.querySelector('[data-vl-gift-txt]');
    const stickyV = document.querySelector('[data-vl-sticky-v]');
    box.querySelectorAll('input[name="vl-tier"]').forEach((r) => r.addEventListener('change', () => {
      idInput.value = r.value;
      prices.forEach((p) => (p.textContent = r.dataset.price));
      if (stickyV) stickyV.textContent = r.dataset.title;
      const on = r.dataset.gift === '1';
      if (gift) { gift.toggleAttribute('data-off', !on); }
      if (giftTxt) giftTxt.textContent = on ? 'Added free to your order' : 'Unlocks with 2+ jars';
    }));
    const main = box.querySelector('[data-gal-main] img');
    box.querySelectorAll('[data-gal-thumb]').forEach((t) => t.addEventListener('click', () => {
      if (main) { main.src = t.dataset.galThumb; main.removeAttribute('srcset'); }
      box.querySelectorAll('[data-gal-thumb]').forEach((x) => x.setAttribute('aria-current', x === t));
    }));
  });

  const sticky = document.querySelector('[data-vl-sticky]');
  const buy = document.querySelector('[data-vl-buy]');
  if (sticky && buy && 'IntersectionObserver' in window) {
    let buyVisible = false;
    const tick = () => sticky.classList.toggle('is-on', !buyVisible && window.scrollY > 700);
    new IntersectionObserver(([e]) => { buyVisible = e.isIntersecting; tick(); }).observe(buy);
    window.addEventListener('scroll', tick, { passive: true });
  }

  document.querySelectorAll('[data-ugc-play]').forEach((b) => b.addEventListener('click', () => {
    const v = b.parentElement.querySelector('video');
    if (!v) return;
    if (v.paused) { v.muted = false; v.play(); b.style.opacity = 0; } else { v.pause(); b.style.opacity = 1; }
  }));
})();
